module.exports = __webpack_public_path__ + "img/sad.92781924.png";